<div class="dropdown-export" [ngClass]="{'crosstalk-keys': showCrosstalkKeysExportToggle}">
    <div class="full-export">
        Export full view

        <button
            id="pdf"
            class="ghost-btn"
            [disabled]="exportWidgetInfos.length === 0"
            (click)="exportDashboard('PDF')"
        >
            PDF
        </button>
    </div>

    <div class="export">
        <div class="export-type">
            <label>Export data</label>

            <cc-option-toggle
                class="export-type-toggle"
                [value]="!isFullExport"
                [labels]="['Filtered', 'Full']"
                [disabled]="exportWidgetInfos.length === 0"
                [ngClass]="{'disabled-toggle': exportWidgetInfos.length === 0}"
                (valueChange)="onExportTypeChange($event)"
            >
            </cc-option-toggle>
        </div>

        @if (showCrosstalkKeysExportToggle) {
            <div class="export-crosstalk-keys">
                <label>Crosstalk keys</label>

                <cc-option-toggle
                    [value]="!includeCrosstalkKeys"
                    [labels]="['Excluded', 'Included']"
                    [disabled]="exportWidgetInfos.length === 0"
                    [ngClass]="{'disabled-toggle': exportWidgetInfos.length === 0}"
                    (valueChange)="onCrosstalkKeyExportChange($event)"
                >
                </cc-option-toggle>
            </div>
        }

        <div class="export-widget-list max-height">
            <cc-checkbox
                #selectAllCheckbox
                [label]="'Select All'"
                [disabled]="exportWidgetInfos.length === 0"
                [(value)]="selectAll.isChecked"
                (valueChange)="onSelectAllChange(selectAllCheckbox.value)"
            >
            </cc-checkbox>

            @for(widget of exportWidgetInfos; track widget.id) {
                <cc-checkbox
                    id="ex-{{widget.id}}"
                    [label]="widget.name"
                    [disabled]="exportWidgetInfos.length === 0"
                    [(value)]="widget.isChecked"
                    (valueChange)="onSelectChange(widget, widget.isChecked)"
                >
                </cc-checkbox>
            }
        </div>

        <div class="button-wrap">
            <button
                id="csv"
                class="ghost-btn"
                [disabled]="!isDataLoaded || !selectedWidgetCount"
                (click)="exportDashboard('CSV')"
            >
                CSV
            </button>

            <button
                id="excel"
                class="ghost-btn"
                [disabled]="!isDataLoaded || !selectedWidgetCount"
                (click)="exportDashboard('EXCEL')"
            >
                EXCEL
            </button>
        </div>
    </div>
</div>
